<template>
  <div class="home_page">
    <el-container>
      <el-header style="margin:0;padding:0;">
        <headerMenu></headerMenu>
      </el-header>
      <el-main style="margin:0;padding:0;">
        <router-view></router-view>
      </el-main>
      <!-- <el-footer>
        <mainBottom></mainBottom>
      </el-footer> -->
      
    </el-container>
  </div>
</template>
<script>
import headerMenu from "../container/headerMenu";
import mainBottom from "../container/bottom";
export default {
  components: {
    headerMenu,
    mainBottom,
  },
};
</script>
